/*
 * Author: Roger
 * File Created: Friday, 24-07-26 04:25 pm
 * Last Modified: Tuesday, 24-11-19 01:47 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
const Withdraw = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Withdraw" data-sentry-source-file="index.tsx">
      <path d="M16.7092 16.4874C16.7092 16.9845 17.1122 17.3874 17.6092 17.3874C18.1063 17.3874 18.5092 16.9845 18.5092 16.4874L18.5092 6.48803C18.5092 5.99097 18.1063 5.5874 17.6092 5.5874L7.60924 5.5874C7.11218 5.5874 6.70924 5.99035 6.70924 6.4874C6.70924 6.98446 7.11218 7.3874 7.60924 7.3874L15.2939 7.3874L5.7807 16.9005C5.42922 17.2519 5.42922 17.8218 5.78069 18.1733C6.13216 18.5247 6.70201 18.5247 7.05348 18.1733L16.7092 8.51764V16.4874Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
};
export default Withdraw;